<template>
    <div class="rightPage">
        <ImgShow class="imgshow rightclass"></ImgShow>
        <div class="rightIntro rightclass">
            <h3>网站简介</h3>
            <br>
            <p><strong>即刻搜索</strong>是一个轻量级别的聚合性搜索网站。</p>
            <br>
            <p>基于以下依赖进行开发：</p>
                <ul>
                    <li>HTML5</li>
                    <li>CSS3</li>
                    <li>JS</li>
                    <li>Vue2.0</li>
                </ul>
            <br>
            <p>目前是学校Web选修课的大作业。<s>能用就行</s></p>
        </div>
        <ToolList class="toolist rightclass"></ToolList>
    </div>
</template>

<script>
import ImgShow from "./ImgShow";
import ToolList from "./ToolList";

export default {
    name: "RightModule",
    components:{
    ImgShow,
    ToolList
    },
}
</script>

<style>
    .rightclass{
        float: left;
        margin: 4em 1em 4em 1em;
    }
    .imgshow{
        
    }
    .toolist{

    }
    .rightIntro{
        width:25em;
        height: 17em;
        border-radius: 0.5em;
        padding: 1em;
        background-color: rgb(206, 232, 255);
    }
    .rightIntro p{
        text-align:left;
    }
    .rightIntro li{
        text-align:left;
        margin-left: 4em;
        list-style-type: circle;
    }
</style>